module.exports = __webpack_public_path__ + "static/media/location1.10d6d0b2.webp";